/* unplugin-vue-components disabled */import script from "./ComplaintGoodComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplaintGoodComponents.vue?vue&type=script&setup=true&lang=js"

import "./ComplaintGoodComponents.vue?vue&type=style&index=0&id=1145a1e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1145a1e0"]])

export default __exports__